import { render } from "./App.vue?vue&type=template&id=77cb08d8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=77cb08d8&lang=less"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2025\\design-competition-2025-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__